import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { CORP_BLUE, FONT_SIZE_UPLOAD } from 'config/config';
import { Preview } from '@mui/icons-material';
import { obtenerArchivoPreview } from 'services/api';

const addStyle = makeStyles(theme => ({
  previewStyle: {
    color: 'black',
    cursor: 'pointer',
    padding: 2,
    '&:hover': {
      color: CORP_BLUE,
    },
  },

  gridRowItem: {
    fontSize: FONT_SIZE_UPLOAD,
    padding: 5,
  },
}));

const ViewHistoriaPrestador = props => {
  const classes = addStyle();
  const { adjuntosPrestador, setLoading, cargarPreview } = props;

  const getPreview = async url => {
    obtenerArchivoPreview(url)
      .then(r => {
        cargarPreview(r.data);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(e => {
        setLoading(false);
      });
  };

  const startPreview = item => {
    setLoading(true);
    getPreview(item);
  };

  return (
    <Grid container>
      {adjuntosPrestador !== null && adjuntosPrestador !== undefined ? (
        adjuntosPrestador.length === 0 ? (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <p>La Aseguradora no ha aportado Documentos.</p>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <p>Documentos aportados por la Aseguradora</p>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    height: 1,
                    backgroundColor: 'gray',
                    marginBottom: 5,
                    marginTop: 5,
                  }}
                />
                <Grid item container xs={12} alignItems="flex-start" style={{ backgroundColor: CORP_BLUE, color: 'white' }}>
                  <Grid item xs={6} style={{ textAlign: 'start' }}>
                    <p className={classes.gridRowItem}>Nombre Adjunto</p>
                  </Grid>
                  <Grid item xs={4} style={{ textAlign: 'start' }}>
                    <p className={classes.gridRowItem}>Fecha creación</p>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'center' }}>
                    <p className={classes.gridRowItem}>Adjunto</p>
                  </Grid>
                </Grid>
                {adjuntosPrestador !== null && adjuntosPrestador !== undefined
                  ? adjuntosPrestador.map((item, index) => {
                      return (
                        <Grid
                          key={index}
                          item
                          container
                          xs={12}
                          alignItems="flex-start"
                          style={{
                            backgroundColor: index % 2 === 0 ? '#ddddee' : 'whitesmoke',
                          }}>
                          <Grid item xs={6} style={{ textAlign: 'start' }}>
                            <p className={classes.gridRowItem}>{item.name}</p>
                          </Grid>
                          <Grid item xs={4} style={{ textAlign: 'start' }}>
                            <p className={classes.gridRowItem}>{item.fecha}</p>
                          </Grid>
                          <Grid item xs={2} style={{ textAlign: 'center' }}>
                            <Preview
                              onClick={() => {
                                startPreview(item.url);
                              }}
                              className={classes.previewStyle}
                              style={{ fontSize: 34 }}
                            />
                          </Grid>
                        </Grid>
                      );
                    })
                  : null}
                <Grid
                  item
                  xs={12}
                  style={{
                    height: 1,
                    backgroundColor: 'gray',
                    marginBottom: 5,
                    marginTop: 5,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        )
      ) : null}
    </Grid>
  );
};

export default ViewHistoriaPrestador;
